// extracted by mini-css-extract-plugin
export default {"input":"style_input__zl70o","copyButton":"style_copyButton__crQts","cancelButton":"style_cancelButton__PK2x2"};